import { Decimal } from "decimal.js";

export const currencyFormat = new Intl.NumberFormat("en", {
  style: "currency",
  currency: "EUR",
  minimumFractionDigits: 0,
  maximumFractionDigits: 2
});

// MAX(50;M^2)/((0.5*79100000/N)*(0.025^ N))
const PROBABILITY_OF_PROTOCOLS = 0.5;
export const getEstimatedCredits = async ({
  nPhotons,
  nModes
}: {
  nPhotons: number;
  nModes: number;
}) => {
  const estimatedCredits = new Decimal(
    Math.max(50, nModes * nModes) /
      (((PROBABILITY_OF_PROTOCOLS * 79100000) / nPhotons) * Math.pow(0.025, nPhotons))
  );

  return {
    estimatedCredits: Math.max(1, estimatedCredits.ceil().toNumber())
  };
};
